// extracted by mini-css-extract-plugin
export default {"resultsCards":"SearchResultGlobal_resultsCards__EZg9D"};